export const lheading = /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/
